import React, { useEffect, useMemo, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import AdLayout from "../../components/AdLayout";
import "./accountingResponsive.css";
import SalaryList from "./SalaryList";
import AdvanceList from "./AdvanceList";
import PrepaidExpenseList from "./PrepaidExpenseList";
import axiosInstance from "../../axiosInstance";
import {
  fetchAccountingPermissions,
  ACCOUNTING_SO_CHI_SALARY,
  ACCOUNTING_SO_CHI_ADVANCE,
  ACCOUNTING_SO_CHI_PREPAID,
} from "../../libs/customerCreatePermission";

const HrAccounting = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "salary";
  const [tabView, setTabView] = useState({});
  const [permLoaded, setPermLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const [salary, advance, prepaid] = await Promise.all([
        fetchAccountingPermissions(axiosInstance, ACCOUNTING_SO_CHI_SALARY),
        fetchAccountingPermissions(axiosInstance, ACCOUNTING_SO_CHI_ADVANCE),
        fetchAccountingPermissions(axiosInstance, ACCOUNTING_SO_CHI_PREPAID),
      ]);
      if (cancelled) return;
      setTabView({
        salary: Boolean(salary?.canView),
        advance: Boolean(advance?.canView),
        prepaid: Boolean(prepaid?.canView),
      });
      setPermLoaded(true);
    })();
    return () => { cancelled = true; };
  }, []);

  const allowedTabs = useMemo(() => {
    const tabs = [];
    if (tabView.salary) tabs.push("salary");
    if (tabView.advance) tabs.push("advance");
    if (tabView.prepaid) tabs.push("prepaid");
    return tabs;
  }, [tabView]);

  useEffect(() => {
    if (!permLoaded || allowedTabs.length === 0) return;
    if (!allowedTabs.includes(tab)) {
      const next = new URLSearchParams(searchParams);
      next.set("tab", allowedTabs[0]);
      setSearchParams(next, { replace: true });
    }
  }, [permLoaded, allowedTabs, tab, searchParams, setSearchParams]);

  const handleTabSelect = (key) => {
    if (!key || !allowedTabs.includes(key)) return;
    const next = new URLSearchParams();
    next.set("tab", key);
    setSearchParams(next);
  };

  if (!permLoaded) return null;

  return (
    <AdLayout>
      <div className="acc-page">
        <h5 className="fw-bold mb-3">Sổ chi</h5>
        <Tabs
          activeKey={allowedTabs.includes(tab) ? tab : allowedTabs[0]}
          onSelect={handleTabSelect}
          className="mb-3 acc-tabs-scroll"
        >
          {tabView.salary && (
            <Tab eventKey="salary" title="Bảng lương">
              {tab === "salary" && <SalaryList embedded />}
            </Tab>
          )}
          {tabView.advance && (
            <Tab eventKey="advance" title="Tạm ứng">
              {tab === "advance" && <AdvanceList embedded />}
            </Tab>
          )}
          {tabView.prepaid && (
            <Tab eventKey="prepaid" title="Chi phí trả trước">
              {tab === "prepaid" && <PrepaidExpenseList embedded />}
            </Tab>
          )}
        </Tabs>
      </div>
    </AdLayout>
  );
};

export default HrAccounting;
